import { whichTarget, isComeOtherRowMessage, removeDraggedComponent, removeNullElements, getMessage } from "../commons";
import { getType } from "../utils";
import { getRowIndex } from "../indexManager/RowIndexManager";

export default (state, indexes) => {
    const { currentEditMessage, currentEditSlidePage } = state
    console.log('state :', state);
    if (currentEditSlidePage) {
      window.alert('그룹 컴포넌트의 페이지 수정 중일 때에는 옮길 수 없습니다.')
      return currentEditMessage
    }
    /**
     * Index 요소 관련
     * message_index는 참조 기준(0부터)으로 잡혀있음
     * row_index, component_index는 사용자 기준(1부터)으로 잡혀있음
     */
    const { message_index_dragged, row_index_dragged, component_index_dragged } = indexes // Dragged component (source)
    const { message_index_target, row_index_target, component_index_target } = indexes // Target index position (target)

    const target = whichTarget(message_index_target, row_index_target, component_index_target)
    console.log('Component index position change to => ', target);

    // const dragged_component = currentEditMessage[message_index_dragged].rows[row_index_dragged].components[component_index_dragged]

    // Updated currentEditMessage 
    let currentEditMessage_updated = null

    const detect = isComeOtherRowMessage({...indexes,
      message_index_dragged: message_index_dragged,
      message_index_target: message_index_target,
      // row_index_dragged: row_index_dragged, 
      row_index_target: row_index_target,
    })
    // console.log('detect :', detect);
    // Common logic (prefix/type)
    const draggedRow = currentEditMessage[message_index_dragged].rows[row_index_dragged]
    // console.log('draggedRow :', draggedRow);
    // const draggedComponent = currentEditMessage[message_index_dragged].rows[row_index_dragged].components[component_index_dragged]
    let prefix_type, type = null
    if (draggedRow) {
      const type_result = getType(draggedRow.attr)
      prefix_type = type_result.prefix
      type = type_result.type
    }

    // Excute logic by target
    switch(target) {
      case "COMPONENT":
        console.log(currentEditMessage[message_index_dragged].rows[row_index_dragged], "Row를",
        currentEditMessage[message_index_target].rows[row_index_target].components[component_index_target], "컴포넌트의 밑으로 이동합니다.");
        // Pass message, row index
        currentEditMessage_updated = currentEditMessage.map((message, i) => {
          let { rows } = message
          let row_split_new_row = null // Row has inserted component (between rows)
          let row_split_splitted_row = null // Row has splitted components
          let first_splitted_row = null // Row has splitted components
          // console.log("===== Dragged process START =====")
          /**
           * Dragged to other element process case
           * 드래그 된 컴포넌트를 전처리에서 삭제함, 해당 컴포넌트의 위치는 null로 채워짐 (Index 유지)
           */
          if (message_index_dragged === i && detect.result) {
            // console.log('수정 할 message detect :', message);
            rows = removeDraggedComponent(rows, row_index_dragged, component_index_dragged)
            // rows = removeNullElements(rows)
            // console.log('수정 후 rows :', rows);
          }
          // console.log("===== Dragged process END =====")

          // console.log('result rows :', rows);

          // console.log("===== Target process START =====")
          // Target process
          if (message_index_target === i) {
            /**
             * Row의 첫번째 컴포넌트 인덱스로 지정했을 시
             * row_index_target을 기반으로 draggedRow 이전까지의 row push
             * draggedRow concat
             * 나머지 남은 Rows concat
             */
            // if (component_index_target === -1) { // Component target index === -1
            //   const 
            //   rows = [draggedRow].concat(rows)
            // } else {
              rows = rows.map((row, i) => {
                if (!row) { // index유지를 위해 null값으로 유지함, remove blank rows 과정을 후처리로 옮겨 null detect 처리
                  return null
                }
                let { components, attr } = row
                // Target process
                if (row_index_target === i) {
                  // const dragged_component = components[component_index_dragged]
                  // Row split condition
                  if (attr !== prefix_type+'/'+type ) {
                    // console.log('== Row split condition detected! ==')
                    const _component_index = component_index_target === -1 ? 0 : component_index_target+1 // index -1 means index 0 
                    // console.log('_component_index :', _component_index);
                    first_splitted_row = {...row,
                      components: components.slice(0, _component_index)
                    }
                    // first_splitted_row = rows.slice(0, _component_index)
                    first_splitted_row = first_splitted_row.components.length <= 0 ? null : first_splitted_row 
                    // console.log('first_splitted_row :', first_splitted_row);

                    row_split_new_row = draggedRow
                    // console.log('row_split_new_row :', row_split_new_row);

                    row_split_splitted_row = {...row,
                      local_id: getRowIndex(),
                      components: components.slice(_component_index, components.length)
                    }
                    // row_split_splitted_row = rows.slice(_component_index+1)
                    row_split_splitted_row = row_split_splitted_row.components.length <= 0 ? null : row_split_splitted_row 
                    // console.log('row_split_splitted_row :', row_split_splitted_row);

                    return first_splitted_row
                  }
                  
                }
                return row
              })
            // }

            const my_row_index = row_index_target === -1 ? 0 : first_splitted_row ? row_index_target+1 : row_index_target
            /**
             * Splice splitted rows 
             * Note: splice condition으로 인해 else if 사용하게 되었음
             */
            if (row_split_new_row && row_split_splitted_row) {
              // row_index_target === -1 ? 0 : first_splitted_row ? row_index_target+1 : row_index_target
              rows.splice(my_row_index, 0, row_split_new_row, row_split_splitted_row)
            } else if (row_split_new_row && !row_split_splitted_row) {
              rows.splice(my_row_index, 0, row_split_new_row)
            }

            rows = removeNullElements(rows) // remove blank rows
            // console.log("After removeNullElements rows -> ", rows)
            console.log('result rows -> ', rows)
            message = {...message, rows: rows,}
          }
          // console.log("===== Target process END =====")

          // console.log('Result rows :', rows);
          // console.log('Result message :', message);


          rows = removeNullElements(rows) // remove blank rows
          // row.length <= compare then return null(message)
          if (rows) {
            if (rows.length <= 0) {
              return null
            }
          }
          return {
            ...message,
            rows: rows,
          }
        })
        // reference components row
        break;
      case "ROW":
        currentEditMessage_updated = currentEditMessage.map((message, i) => {
          let { rows } = message
          console.log('[Test] before rows :', rows)
          console.log('== dragged 삭제 process ==')
          if (i === message_index_dragged) {
            rows = removeDraggedComponent(rows, row_index_dragged)
          }
          console.log('dragged 삭제 result :', rows)
          console.log('== target process ==')
          // Target process
          if (message_index_target === i) {
            console.log(message, "를 타겟으로 업데이트를 시작")
            let updated_rows = []
            // If first index, then push at first and concat
            if (row_index_target === -1) {
              console.log('=== row target is -1 ===')
              updated_rows.push(draggedRow)
              updated_rows = updated_rows.concat(rows)
              console.log('result: ', updated_rows)
            } else { // normal case
              rows.map((row, i) => {
                // Target process
                if (row) {
                  updated_rows.push(row)
                  console.log('row pushed :', row);
                }
                // !!TODO 0번째 인덱스로 옮겼을 시 처리가 필요한 것 같음 !!
                if (row_index_target === i) {
                  updated_rows.push(draggedRow) // Component menu type 맞춤
                  console.log('draggedRow pushed :', draggedRow);
                  // origin code !!MUST EXPLAIN(_NORMAL_TEXT)? // updated_rows.push(getRow("_"+prefix_type, "_"+type)) // Component menu type 맞춤
                }
              })
            }

            console.log('== remove nulls ==')
            updated_rows = removeNullElements(updated_rows)
            message = {...message, rows: updated_rows,}
            return message
          }

          console.log('result: ', rows)
          rows = removeNullElements(rows)
          if (rows) {
            if (rows.length <= 0) {
              console.log('row.lengt is <=0, return null')
              return null
            }
          }
          
          console.log('complete rows :', rows);
          return {
            ...message,
            rows: rows,
          }
        })
        break;

      case "MESSAGE":
        // const draggedRow = editCurrentMessage[message_index_dragged].rows[row_index_dragged]
        let createdMessageInstance = getMessage(prefix_type, type, [draggedRow]) // Option parameter ([draggedComponent])

        // Remove dragged component
        currentEditMessage_updated = currentEditMessage.map((message, i) => {
          if (i === message_index_dragged) {
            let { rows } = message
            rows = removeDraggedComponent(rows, row_index_dragged)
            return {...message,
              rows: rows,
            }
          }
          return message
        })

        // Target index 0
        if (message_index_target === 0) {
          // createdMessageInstance["rows"]
          currentEditMessage_updated = [createdMessageInstance].concat(currentEditMessage_updated)
        } else { // Target 1, 2, 3 ...
          currentEditMessage_updated.splice(message_index_target, 0, createdMessageInstance)
          currentEditMessage_updated = currentEditMessage_updated.map(message => (message)) // TODO 최적화 immutable 관련 
        }
        
        // Remove rows nulls, rows.length === 0 compare
        currentEditMessage_updated = currentEditMessage_updated.map(message => {
          let { rows } = message
          rows = removeNullElements(rows)
          // row.length is 0 or under then return null (after remove)
          if (rows) {
            if (rows.length <= 0) {
              return null
            }
          }
          console.log('complete rows :', rows);
          return {
            ...message,
            rows: rows,
          }
        })
        break;
      
      default:
        console.error('Depth 컴포넌트는 Message/Row scope 이외 영역으로 옮길 수 없습니다.')
        window.alert('컴포넌트를 정상적으로 옮기지 못하였습니다.')
        return {
          ...state,
        }
    }
    // Remove nulls
    currentEditMessage_updated = removeNullElements(currentEditMessage_updated)

    console.log('Result currentEditMessage_updated :', currentEditMessage_updated);
    return currentEditMessage_updated
  }